"use strict";

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

// Global variables
var scrollTopPos = 0;
var justClosedModal = false;
var modalIframe = null;
var bodyLockCount = 0;
var bodyLockScrollY = 0;
var lenisResizeRaf = null;

function syncMenuButtons() {
    var isMenuOpen = !!document.querySelector('[data-modal="menu"].is-show');
    document.querySelectorAll(".header__icon-btn--menu[data-menu-trigger]").forEach(function (button) {
        button.classList.toggle("is-active", isMenuOpen);
    });
}

function toggleBodyLock(action) {
    if (action === "lock") {
        bodyLockCount += 1;
        if (bodyLockCount > 1) return;
        bodyLockScrollY = window.scrollY || window.pageYOffset || 0;
        document.body.classList.add("lock", "full-lock");
        document.body.style.top = -bodyLockScrollY + "px";
        return;
    }
    bodyLockCount = Math.max(0, bodyLockCount - 1);
    if (bodyLockCount !== 0) return;
    document.body.classList.remove("lock", "full-lock");
    document.body.style.top = "";
    window.scrollTo(0, bodyLockScrollY);
    bodyLockScrollY = 0;
}

function openModal(modalName, url) {
    var modal = document.querySelector('[data-modal="' + modalName + '"]');
    if (!modal) { return; }

    Array.from(document.querySelectorAll("[data-modal].is-show")).forEach(function (opened) {
        var openedName = opened.getAttribute("data-modal");
        if (openedName !== modalName) {
            closeModal(openedName, { skipScrollSync: true });
        }
    });

    modal.classList.remove("is-hide");
    modal.classList.add("is-show");
    document.body.classList.add("modal-open");

    if (modalName === "menu") {
        document.body.classList.add("is-menu-open");
        syncMenuButtons();
    }

    // reCAPTCHA is lazy-loaded on interaction. Guarantee it starts loading the
    // moment the form modal opens so it is ready before the user can submit.
    if (modalName === 'pre-register' && typeof window.__loadRecaptcha === 'function') {
        window.__loadRecaptcha();
    }

    toggleBodyLock("lock");
}

function closeModal(modalName, options) {
    var modal = document.querySelector('[data-modal="' + modalName + '"]');
    if (!modal) return;
    var opts = options || {};
    var skipScrollSync = !!opts.skipScrollSync;

    modal.classList.remove("is-show");
    modal.classList.add("is-hide");

    if (modalName === "menu") {
        document.body.classList.remove("is-menu-open");
        syncMenuButtons();
    }

    if (!document.querySelector("[data-modal].is-show")) {
        document.body.classList.remove("modal-open");
        toggleBodyLock("unlock");
    }

    justClosedModal = true;
    window.dispatchEvent(new Event("scroll"));
}

function toggleModal(modalName, url) {
    var modal = document.querySelector('[data-modal="' + modalName + '"]');
    if (!modal) return;
    if (modal.classList.contains("is-show")) {
        closeModal(modalName);
    } else {
        openModal(modalName, url);
    }
}

function initModals() {
    document.querySelectorAll("[data-modal-toggle]").forEach(function (toggle) {
        toggle.addEventListener("click", function (event) {
            if (toggle.tagName === "A") {
                event.preventDefault();
            }
            var modalName = toggle.getAttribute("data-modal-toggle");
            var url = toggle.dataset.url !== undefined ? toggle.dataset.url : null;
            toggleModal(modalName, url);
        });
    });

    document.addEventListener("click", function (event) {
        var openModalEl = document.querySelector("[data-modal].is-show");
        if (!openModalEl) return;

        if (openModalEl.classList.contains("s-menu") && event.target === openModalEl) {
            closeModal(openModalEl.getAttribute("data-modal"));
            return;
        }

        if (event.target.classList.contains("s-modal__wrapper")) {
            closeModal(openModalEl.getAttribute("data-modal"));
        }
    });

    // Global: any anchor with #pre-register opens the modal (any path)
    document.addEventListener('click', function (event) {
        var link = event.target.closest('a[href]');
        if (!link) return;
        var href = link.getAttribute('href') || '';
        if (!href) return;
        if (href.indexOf('#pre-register') !== -1) {
            // If clicked inside the mobile menu, close it first and then open modal after a short delay
            var inMenu = !!link.closest('.s-menu');
            
            if (inMenu) {
                // Let the mobile handler below manage closing and opening
                return;
            }
            event.preventDefault();
            openModal('pre-register');
        }
    });

    // Close the mobile menu before navigating when a mobile menu link is clicked
    document.addEventListener("click", function (event) {
        var link = event.target.closest('.s-menu__link');
        if (!link) return;

        var href = link.getAttribute('href');
        if (!href) return;
        if (link.hasAttribute('data-modal-toggle')) return;
        if (/^javascript:/i.test(href)) return;

        // Special-case: any mobile link to #pre-register should open modal
        if (href.indexOf('#pre-register') !== -1) {
            event.preventDefault();
            closeModal('menu');
            
            setTimeout(function(){ openModal('pre-register'); }, 200);
            return;
        }

        event.preventDefault();

        var target = (link.getAttribute('target') || '').toLowerCase();

        // Close the menu modal first
        closeModal('menu');

        var navigate = function () {
            if (target === '_blank') {
                window.open(href, '_blank', 'noopener');
            } else {
                window.location.href = href;
            }
        };

        // Respect the CSS transition duration for a smoother feel
        var surface = document.querySelector('.s-menu__surface');
        var durationMs = 250;
        if (surface) {
            var cs = window.getComputedStyle(surface);
            var dur = cs.transitionDuration || '0s';
            // transitionDuration can be comma-separated; take the first
            var first = dur.split(',')[0].trim();
            // parse seconds (e.g., "0.3s") or milliseconds (e.g., "300ms")
            if (first.endsWith('ms')) {
                durationMs = parseFloat(first);
            } else if (first.endsWith('s')) {
                durationMs = parseFloat(first) * 1000;
            }
            // Add a small buffer
            durationMs = Math.max(200, Math.min(800, durationMs + 50));
        }

        setTimeout(navigate, durationMs);
    });

    document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape") return;
        Array.from(document.querySelectorAll("[data-modal].is-show")).forEach(function (modal) {
            closeModal(modal.getAttribute("data-modal"));
        });
    });
}

function initAccordions() {
    var roots = Array.from(document.querySelectorAll("[data-accordion-root]"));
    if (!roots.length) return;

    roots.forEach(function (root) {
        var items = Array.from(root.querySelectorAll("[data-accordion-item]"));
        if (!items.length) return;

        var isSingle = root.hasAttribute("data-accordion-single");

        function setState(item, isOpen, skipAnimation) {
            var trigger = item.querySelector("[data-accordion-trigger]");
            var panel = item.querySelector("[data-accordion-panel]");
            if (!trigger || !panel) return;

            item.classList.toggle("is-open", isOpen);
            trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");

            if (skipAnimation) {
                panel.style.maxHeight = isOpen ? "none" : "0px";
                if (isOpen) {
                    requestAnimationFrame(function () {
                        panel.style.maxHeight = panel.scrollHeight + "px";
                    });
                }
                return;
            }

            panel.style.maxHeight = isOpen ? panel.scrollHeight + "px" : "0px";
        }

        items.forEach(function (item) {
            setState(item, item.classList.contains("is-open"), true);
            var trigger = item.querySelector("[data-accordion-trigger]");
            if (!trigger) return;
            var panel = item.querySelector("[data-accordion-panel]");
            if (panel) {
                panel.addEventListener("transitionend", function (event) {
                    if (event.propertyName !== "max-height") return;
                    requestAnimationFrame(function () {
                        panel.style.maxHeight = item.classList.contains("is-open") ? panel.scrollHeight + "px" : "0px";
                    });
                });
            }

            trigger.addEventListener("click", function () {
                var willOpen = !item.classList.contains("is-open");
                if (isSingle && willOpen) {
                    items.forEach(function (otherItem) {
                        if (otherItem === item) return;
                        setState(otherItem, false, false);
                    });
                }
                setState(item, willOpen, false);
            });
        });
    });
}

function initStickyHeader() {
    var sticky  = document.querySelector('.header-wrapper--sticky');
    if (!sticky) return;

    var ticking = false;

    function setVisible(isVisible) {
        sticky.classList.toggle('is-visible', !!isVisible);
    }

    function handleScroll() {
        if (document.body.classList.contains('modal-open')) return;
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(function () {
            var currentY = window.scrollY || window.pageYOffset || 0;

            if (justClosedModal) {
                justClosedModal = false;
                setVisible(currentY > 200);
                scrollTopPos = currentY;
                ticking = false;
                return;
            }

            var deltaY = currentY - scrollTopPos;
            var directionThreshold = 2;
            var scrollingUp = deltaY < -directionThreshold;
            var scrollingDown = deltaY > directionThreshold;

            if (currentY > 200 && scrollingUp) {
                setVisible(true);
            } else if (currentY <= 200 || scrollingDown) {
                setVisible(false);
            }

            scrollTopPos = currentY;
            ticking = false;
        });
    }

    // Prime initial state and bind listeners
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
}

// ─── In-View Detection (fade-in on enter) ──────────────────────────────────
function initInViewDetect(delay) {
    var delayTime = delay || 0;
    var blocks = document.querySelectorAll('.in-view-detect, .in-view-detect-tag > *');
    if (!blocks.length) return;

    function handleEnter(el) {
        if (el.classList.contains('in-view')) return;
        el.classList.remove('in-view-detect');
        el.classList.add('in-view');
    }

    function fallbackInit() {
        var vh = window.innerHeight;
        function check() {
            blocks.forEach(function (item) {
                if (!item || item.classList.contains('in-view')) return;
                var rect = item.getBoundingClientRect();
                var parent = item.parentElement;
                var offset = (parent && parent.classList.contains('in-view-detect-tag--flush')) ? 0 : 80;
                if (rect.top < vh - offset) {
                    handleEnter(item);
                }
            });
        }
        window.addEventListener('scroll', check, { passive: true });
        window.addEventListener('resize', function() { vh = window.innerHeight; check(); });
        check();
    }

    function makeObserver(rootMargin) {
        return new IntersectionObserver(function (entries, obs) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                var el = entry.target;
                if (el.classList.contains('in-view')) return;
                handleEnter(el);
                obs.unobserve(el);
            });
        }, { root: null, rootMargin: rootMargin, threshold: 0 });
    }

    function ioInit() {
        // Main observer: -80px bottom offset gives a staggered feel as blocks enter.
        // Flush observer: 0px offset for elements near the bottom of the page
        // (e.g. footer children) that would otherwise sit in the dead zone.
        var observer      = makeObserver('0px 0px -80px 0px');
        var observerFlush = makeObserver('0px');

        blocks.forEach(function (el) {
            var parent = el.parentElement;
            if (parent && parent.classList.contains('in-view-detect-tag--flush')) {
                observerFlush.observe(el);
            } else {
                observer.observe(el);
            }
        });
    }

    setTimeout(function () {
        if ('IntersectionObserver' in window) {
            ioInit();
        } else {
            fallbackInit();
        }
    }, delayTime);
}

// ─── Smooth Anchor Scrolling (Lenis-aware) ─────────────────────────────────
function initSmoothAnchors() {
    function isSamePage(url) {
        try {
            var u = new URL(url, window.location.href);
            return u.origin === window.location.origin && u.pathname === window.location.pathname;
        } catch (e) { return false; }
    }

    function getHeaderOffset() {
        var offset = 0;
        var sticky = document.querySelector('.header-wrapper--sticky');
        if (sticky) {
            var wasVisible = sticky.classList.contains('is-visible');
            // If not visible yet, we still measure its height as a conservative offset
            var rect = sticky.getBoundingClientRect();
            if (rect && rect.height) offset = Math.max(offset, rect.height);
            // If visible, definitely use it
            if (wasVisible) offset = Math.max(offset, rect.height || 0);
        }
        return offset;
    }

    function scrollToTarget(targetEl) {
        if (!targetEl) return;
        var offset = getHeaderOffset();
        
        if (window.lenis && typeof window.lenis.scrollTo === 'function') {
            window.lenis.scrollTo(targetEl, { offset: -offset, duration: 1.6 });
        } else if ('scrollBehavior' in document.documentElement.style) {
            var top = targetEl.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: top, behavior: 'smooth' });
        } else {
            var top2 = targetEl.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo(0, top2);
        }
    }

    function handleClick(e) {
        var a = e.currentTarget;
        if (!a || a.dataset.noSmooth === 'true') return;
        if (a.hasAttribute('data-modal-toggle')) return; // let modal handler manage it
        var href = a.getAttribute('href') || '';
        if (!href || href === '#') return;
        if (!href.includes('#')) return;

        // Only intercept same-page anchors
        if (!isSamePage(href)) return;

        var id = href.split('#')[1];
        if (!id) return;
        // Let modal handler manage #pre-register
        if (decodeURIComponent(id) === 'pre-register') { return; }
        var target = document.getElementById(decodeURIComponent(id));
        if (!target) return;

        e.preventDefault();
        // Close mobile menu if open
        if (document.body.classList.contains('is-menu-open') && typeof closeModal === 'function') {
            closeModal('menu');
        }
        scrollToTarget(target);
    }

    // Bind to desktop header (both normal and sticky), and mobile menu links
    var selectors = [
        '.header__nav-list a[href*="#"]',
        '.s-menu__link[href*="#"]',
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function (a) {
        a.addEventListener('click', handleClick);
    });
}

// ─── Lenis Smooth Scroll ────────────────────────────────────────────────────
function requestLenisResize() {
    if (!window.lenis || typeof window.lenis.resize !== "function") return;

    if (lenisResizeRaf) cancelAnimationFrame(lenisResizeRaf);
    lenisResizeRaf = requestAnimationFrame(function () {
        if (window.lenis && typeof window.lenis.resize === "function") {
            window.lenis.resize();
        }
        lenisResizeRaf = null;
    });
}

function initLenis() {
    if (typeof Lenis === "undefined") return;
    // Touch devices get native scroll. smoothTouch is false, so Lenis does nothing
    // on mobile — skip the whole init to avoid a continuous 60fps RAF drain.
    if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;

    var lenis = new Lenis({
        smoothWheel: true,
        smoothTouch: false,
        lerp: 0.1,
        autoResize: false,
    });

    window.lenis = lenis;
    
    window.addEventListener("resize", function () {
        requestLenisResize();
    });
    requestLenisResize();

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
}

document.addEventListener('DOMContentLoaded', function () {
    // Critical — must be wired before any user gesture
    initModals();
    initStickyHeader();
    initLenis();

    // Non-critical — defer until the browser has free cycles
    var ric = window.requestIdleCallback || function (fn) { setTimeout(fn, 50); };
    ric(function () {
        initAccordions();
        initSmoothAnchors();
        initInViewDetect();
    });
});

